<template class="bg-white">
  <div>
    <modal-loading
      v-if="isLoading"
      :openModal="isLoading"
      :value="100"
      :variant="'white'"
      :animated="false"
      :label="'carregando...'"
    >
    </modal-loading>

    <div
      v-if="!isDetaisInModal"
      class="barrasuperior hoverlink"
      @click="goToSite()"
    >
      <span class="w-100 d-block text-center" style="vertical-align: middle">
        <img
          src="img/janoo-logo-v2-high-color.png"
          style="max-width: 180px; height: auto"
          class="justify-content-center align-items-center display-flex"
        />
      </span>
    </div>

    <b-container
      :class="
        !isDetaisInModal
          ? 'mt-6 mb-5 d-flex justify-content-center'
          : 'mb-4 pl-5'
      "
    >
      <b-row align-v="end">
        <b-col>
          <!-- <h2>Detalhes da Reserva</h2> -->
        </b-col>
      </b-row>
    </b-container>

    <div v-if="!isLoading">
      <div v-if="isValidBooking" class="content-info-area">
        <div class="ticketarea scrollbar-inner" style="width: 520px">
          <div class="d-flex">
            <div
              class="ticketstatus"
              :style="`background-color: ${
                bookingDetails.statusColor || 'rgb(33, 122, 159)'
              };`"
            ></div>
          </div>

          <div>
            <div class="ticket" style="margin-top: -110px">
              <div
                class="ticketheaderborder"
                :style="`border-bottom: 2px dashed ${bookingDetails.statusColor};`"
              >
                <div
                  class="ticketheader"
                  :style="`border-bottom-color: ${bookingDetails.statusColor};
                background: radial-gradient(circle 3px at bottom left, ${bookingDetails.statusColor} 85%, white) bottom left, radial-gradient(circle 3px at bottom right, ${bookingDetails.statusColor} 85%, white) bottom right;
                background-size:50% 100%; background-repeat:no-repeat;`"
                >
                  <div class="headerinfos">
                    <div class="iconarea">
                      <div class="ticketicon">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2984_25576)">
                            <path
                              d="M28.6667 29.3346H3.33333C1.496 29.3346 0 27.8386 0 26.0013V23.3346C0 22.9666 0.298667 22.668 0.666667 22.668H1.33333C2.804 22.668 4 21.472 4 20.0013C4 18.5306 2.804 17.3346 1.33333 17.3346H0.666667C0.298667 17.3346 0 17.036 0 16.668V14.0013C0 12.164 1.496 10.668 3.33333 10.668H28.6667C30.504 10.668 32 12.164 32 14.0013V16.668C32 17.036 31.7013 17.3346 31.3333 17.3346H30.6667C29.196 17.3346 28 18.5306 28 20.0013C28 20.7133 28.2773 21.3826 28.7813 21.8866C29.284 22.3906 29.9533 22.668 30.6653 22.668H31.332C31.7 22.668 31.9987 22.9666 31.9987 23.3346V26.0013C32 27.8386 30.504 29.3346 28.6667 29.3346ZM1.33333 24.0013V26.0013C1.33333 27.104 2.23067 28.0013 3.33333 28.0013H28.6667C29.7693 28.0013 30.6667 27.104 30.6667 26.0013V24.0013C29.5987 24.0013 28.5933 23.5853 27.8387 22.8306C27.0827 22.0746 26.6667 21.0693 26.6667 20.0013C26.6667 17.796 28.4613 16.0013 30.6667 16.0013V14.0013C30.6667 12.8986 29.7693 12.0013 28.6667 12.0013H3.33333C2.23067 12.0013 1.33333 12.8986 1.33333 14.0013V16.0013C3.53867 16.0013 5.33333 17.796 5.33333 20.0013C5.33333 22.2066 3.53867 24.0013 1.33333 24.0013Z"
                              fill="#131313"
                            />
                            <path
                              d="M11.3334 13.3346C10.9654 13.3346 10.6667 13.036 10.6667 12.668V11.3346C10.6667 10.9666 10.9654 10.668 11.3334 10.668C11.7014 10.668 12.0001 10.9666 12.0001 11.3346V12.668C12.0001 13.036 11.7014 13.3346 11.3334 13.3346Z"
                              fill="#131313"
                            />
                            <path
                              d="M11.3334 24.6161C10.9654 24.6161 10.6667 24.3174 10.6667 23.9494V21.6947C10.6667 21.3267 10.9654 21.0281 11.3334 21.0281C11.7014 21.0281 12.0001 21.3254 12.0001 21.6947V23.9507C12.0001 24.3187 11.7014 24.6161 11.3334 24.6161ZM11.3334 18.9761C10.9654 18.9761 10.6667 18.6774 10.6667 18.3094V16.0534C10.6667 15.6854 10.9654 15.3867 11.3334 15.3867C11.7014 15.3867 12.0001 15.6854 12.0001 16.0534V18.3094C12.0001 18.6774 11.7014 18.9761 11.3334 18.9761Z"
                              fill="#131313"
                            />
                            <path
                              d="M11.3334 29.3346C10.9654 29.3346 10.6667 29.036 10.6667 28.668V27.3346C10.6667 26.9666 10.9654 26.668 11.3334 26.668C11.7014 26.668 12.0001 26.9666 12.0001 27.3346V28.668C12.0001 29.036 11.7014 29.3346 11.3334 29.3346Z"
                              fill="#131313"
                            />
                            <path
                              d="M3.3334 11.9991C3.06273 11.9991 2.80806 11.8338 2.7094 11.5658C2.58006 11.2205 2.75473 10.8365 3.10006 10.7085L24.3001 2.79245C25.3307 2.40579 26.5414 2.98445 26.8934 4.02312L29.2974 11.1178C29.4147 11.4671 29.2281 11.8445 28.8801 11.9631C28.5347 12.0818 28.1534 11.8938 28.0347 11.5458L25.6307 4.45112C25.5134 4.10445 25.1107 3.91512 24.7654 4.04045L3.5654 11.9565C3.4894 11.9858 3.41073 11.9991 3.3334 11.9991Z"
                              fill="#131313"
                            />
                          </g>

                          <defs>
                            <clipPath id="clip0_2984_25576">
                              <rect width="32" height="32" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>

                      <div class="reservation-code align-items-center">
                        <div
                          style="
                            color: black;
                            font-weight: 600;
                            font-size: large;
                          "
                        >
                          {{
                            bookingDetails.payload
                              ? '#' + bookingDetails.payload.booking_code
                              : ''
                          }}
                        </div>
                        <div
                          class="text-gray mt-0 ml-2"
                          style="font-size: small; line-height: 100%"
                        ></div>
                      </div>
                    </div>

                    <div class="statuscontent">
                      <div class="reservation-status-info">
                        <div class="text-black d-flex" style="font-size: small">
                          Situação:
                          <div
                            class="pl-1"
                            :style="`color: ${
                              bookingDetails.statusColor || 'rgb(33, 122, 159)'
                            }`"
                          >
                            {{ bookingDetails.statusText }}
                          </div>
                        </div>

                        <div class="text-black d-flex" style="font-size: small">
                          Tipo:
                          <div
                            class="pl-1"
                            :style="`color: ${
                              bookingDetails.statusColor || 'rgb(33, 122, 159)'
                            }`"
                          >
                            {{ bookingDetails.channelText }}
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="canShowBookingActions"
                        class="text-right"
                      >
                        <b-dropdown
                          menu
                          on
                          right
                          no-caret
                          id="dropdown-1"
                          class="boton"
                          variant="boton"
                          style="padding: 0"
                        >
                          <template
                            v-slot:button-content
                            class="boton"
                            style="padding: 0"
                          >
                            <svg
                              width="5"
                              height="19"
                              viewBox="0 0 5 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="2.19231"
                                cy="2.19231"
                                r="2.19231"
                                fill="#303030"
                              />
                              <circle
                                cx="2.19231"
                                cy="9.49992"
                                r="2.19231"
                                fill="#303030"
                              />
                              <circle
                                cx="2.19231"
                                cy="16.8078"
                                r="2.19231"
                                fill="#303030"
                              />
                            </svg>
                          </template>

                          <b-dropdown-item
                            @click="changeBookingDate()"
                            :disabled="
                              getCheckins().length > 0 ||
                              bookingDetails.status == 'CANCELLED'
                            "
                            class="a"
                            active:loading="loadingTable"
                            type="default"
                            href="#"
                            target="_self"
                          >
                            <i v-if="!isLoading" class="no no-edit"></i>Alterar
                            data e horário
                          </b-dropdown-item>

                          <b-dropdown-item
                            @click="changeBookingTicketsModal()"
                            :disabled="
                              getCheckins().length > 0 &&
                              !isCurrentUserSystemAdmin
                            "
                            class="a"
                            active:loading="loadingTable"
                            type="default"
                            href="#"
                            target="_self"
                          >
                            <i v-if="!isLoading" class="no no-user"></i>Alterar
                            ingressos
                          </b-dropdown-item>

                          <b-dropdown-item
                            @click="bookingCancelation()"
                            :disabled="
                              bookingDetails.status == 'CANCELLED' ||
                              (getCheckins().length > 0 &&
                                disableAfterNextMonthFifthBussinessDay())
                            "
                            active:loading="loadingTable"
                            type="default"
                          >
                            <i v-if="!isLoading" class="no no-c-remove-2"></i
                            >Cancelar Reserva
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="ticketinfo"
                :style="`background: radial-gradient(circle 3px at top left, ${bookingDetails.statusColor} 85%, white) top left, radial-gradient(circle 3px at top right, ${bookingDetails.statusColor} 85%, white) top right;
              background-color: #FFF; background-size:50% 100%; background-repeat:no-repeat;`"
              >
                <div style="color: black; font-weight: 600; font-size: large">
                  {{ bookingDetails.payload.product.name }}
                </div>

                <div class="d-flex align-items-center">
                  <svg
                    width="10"
                    height="12"
                    viewBox="0 0 10 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.306 0.0078125C2.8389 0.0078125 0.831787 1.88936 0.831787 4.20209C0.831787 7.07226 4.83577 11.2858 5.00624 11.4638C5.16636 11.631 5.44592 11.6307 5.60576 11.4638C5.77623 11.2858 9.78021 7.07226 9.78021 4.20209C9.78016 1.88936 7.77307 0.0078125 5.306 0.0078125ZM5.306 6.31235C4.06474 6.31235 3.05493 5.3657 3.05493 4.20209C3.05493 3.03849 4.06477 2.09186 5.306 2.09186C6.54723 2.09186 7.55704 3.03851 7.55704 4.20212C7.55704 5.36572 6.54723 6.31235 5.306 6.31235Z"
                      fill="black"
                    />
                  </svg>

                  <div class="text-black pl-2" style="font-size: small">
                    {{ bookingDetails.payload.product.place }}
                  </div>
                </div>

                <div class="d-flex align-items-start pt-4">
                  <div class="d-block" style="width: 210px">
                    <div
                      style="color: #a7aa37; font-weight: 700; font-size: small"
                    >
                      Agendado para:
                    </div>
                    <div style="color: #131313; font-size: 14px">
                      {{
                        formattedDate(
                          bookingDetails.payload.booking_date,
                          'DD/MM/YY, H:mm'
                        )
                          .replace(':00', 'h')
                          .replace(':', 'h')
                      }}
                    </div>

                    <div
                      class="pt-4"
                      style="color: #a7aa37; font-weight: 700; font-size: small"
                    >
                      Reservado para:
                    </div>
                    <div style="color: #131313; font-size: 14px">
                      {{
                        bookingDetails.payload.costumer.name
                          .replace('Visitante (', '')
                          .replace(')', '')
                          .trim()
                          .split('(')[0] || 'nome não informado'
                      }}
                    </div>

                    <div
                      class="d-flex align-items-center pt-4"
                      :class="conductors.length > 0 ? 'pb-0' : 'pb-4'"
                    >
                      <div
                        style="
                          color: #a7aa37;
                          font-weight: 700;
                          font-size: small;
                        "
                      >
                        Condução:
                      </div>
                      <span
                        v-if="canAssignResourcesAndConductors"
                        @click.prevent="openAgentSelectorModal()"
                        class="pl-2 btn-inner--icon"
                        type="button"
                      >
                        <i
                          class="no-sm no no-plus text-white bg-success circle"
                          style="padding: 4px"
                        ></i>
                      </span>
                    </div>
                  </div>

                  <div class="d-block">
                    <div
                      style="color: #a7aa37; font-weight: 700; font-size: small"
                    >
                      Grupo:
                    </div>
                    <div style="color: #131313">
                      {{ visitorsAmount() }}
                    </div>

                    <div
                      v-for="(t, i) in bookingTickets"
                      :key="i"
                      style="color: #3a3a3a; font-size: smaller; width: 130px"
                    >
                      {{ t.quantity > 0 ? ticketResume(t) : '' }} <br />
                    </div>

                    <div
                      v-if="
                        bookingDetails.payload != undefined &&
                        (bookingDetails.payload.coupon != undefined ||
                          bookingDetails.payload.order != undefined)
                      "
                      class="text-gray"
                      style="font-size: smaller"
                    >
                      {{
                        bookingDetails.payload.order.total_discount > 0
                          ? 'Desconto: ' +
                            Number(
                              bookingDetails.payload.order.total_discount
                            ).toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })
                          : ''
                      }}
                      {{
                        bookingDetails.payload.coupon != undefined
                          ? 'CUPOM: ' + bookingDetails.payload.coupon.code
                          : ''
                      }}
                    </div>

                    <div
                      style="color: black; font-size: 14px; font-weight: 600"
                    >
                      Total:
                      {{
                        bookingDetails.payload.order != undefined
                          ? Number(
                              bookingDetails.payload.order.final_value
                            ).toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })
                          : ''
                      }}
                    </div>
                  </div>
                </div>

                <div
                  v-for="(agent, idx) in conductors"
                  :key="idx"
                  :class="idx == conductors.length - 1 ? 'pb-4' : 'pb-0'"
                  class="text-black pl-1"
                  style="font-size: small"
                >
                  <div v-if="agent.active">
                    <span
                      @click="handleView(agent.uuid)"
                      class="pl-2 btn-inner--icon"
                      type="button"
                    >
                      <i class="no no-profile-3 text-dark"></i>
                    </span>

                    {{ agent.name }}
                    <span v-if="agent.source === 'vehicle'" class="text-muted">
                      · motorista do {{ vehicleNameByUuid(agent.vehicle_uuid) }}
                    </span>

                    <!-- A cópia do motorista é da saída: muda-se no painel de carros -->
                    <span
                      v-if="isUserAuthorizedBookingEditor && agent.source !== 'vehicle'"
                      @click="removeAgent(agent)"
                      class="pl-2 btn-inner--icon"
                      type="button"
                    >
                      <i
                        v-if="removingAgentUuid === agent.uuid"
                        class="fas fa-spinner fa-spin text-muted"
                        title="Removendo…"
                      ></i>
                      <i v-else class="no no-trash text-danger"></i>
                    </span>
                  </div>
                </div>

                <div
                  v-if="!conductors || conductors.length == 0"
                  class="text-black pl-1"
                  style="font-size: small"
                >
                  <div>Sem condutor</div>
                </div>

                <div
                v-if="slotVehicles.length > 0"
                  class="d-flex align-items-center pt-2"
                  :class="bookingVehicles.length > 0 ? 'pb-0' : 'pb-4'"
                >
                  <div
                    style="color: #a7aa37; font-weight: 700; font-size: small"
                  >
                    Veículo:
                  </div>
                  <span
                    v-if="canAssignResourcesAndConductors"
                    @click.prevent="openVehicleSelectorModal()"
                    class="pl-2 btn-inner--icon"
                    type="button"
                  >
                    <i
                      class="no-sm no no-plus text-white bg-success circle"
                      style="padding: 4px"
                    ></i>
                  </span>
                </div>

                <div
                  v-for="(vehicle, idx) in bookingVehicles"
                  :key="vehicle.uuid || idx"
                  :class="idx == bookingVehicles.length - 1 ? 'pb-4' : 'pb-0'"
                  class="text-black pl-1"
                  style="font-size: small"
                >
                  <i class="fas fa-car text-dark"></i>
                  {{ vehicle.name }}
                  <span v-if="vehicle.plate"> · {{ vehicle.plate }}</span>
                  <span v-if="vehicle.pax != null">
                    · {{ vehicle.pax }} de {{ bookingTotalPax }} pessoas</span
                  >
                  <span
                    v-if="isUserAuthorizedBookingEditor"
                    @click="removeVehicle(vehicle)"
                    class="pl-2 btn-inner--icon"
                    type="button"
                  >
                    <i
                      v-if="removingVehicleUuid === vehicle.uuid"
                      class="fas fa-spinner fa-spin text-muted"
                      title="Removendo…"
                    ></i>
                    <i v-else class="no no-trash text-danger"></i>
                  </span>
                </div>

                <div
                  v-if="!bookingVehicles.length"
                  class="text-black pl-1 pb-4"
                  style="font-size: small"
                >
                  <div>Sem veículo</div>
                </div>
              </div>

              <div class="ticketfooter">
                <div v-if="DEVICE != 'TOTEM'" class="d-block align-items-start">
                  <div>
                    <template v-if="getCheckins().length == 0">
                      <div
                        style="color: black; font-weight: 700; font-size: small"
                      >
                        Aguardando Check-in
                      </div>
                      <div class="pt-1" style="color: gray; font-size: small">
                        --
                      </div>
                    </template>

                    <template v-else>
                      <div
                        style="color: black; font-weight: 700; font-size: small"
                      >
                        Check-in confirmado por:
                      </div>
                      <!-- <div v-for="(checkin, idx) in getCheckins()" :key="idx" class="pt-1" style="color: gray; font-size: small;">
                      {{ checkin.name ? checkin.name : checkin.operator }} ({{ checkin.date.indexOf('-') > 0 ? formattedDate(checkin.date) : checkin.date }})
                    </div> -->
                      <div v-html="getCheckinDetails(bookingDetails)"></div>
                    </template>
                  </div>

                  <span
                    class="ml-auto btn-inner--icon d-block align-items-center"
                  >
                    <div class="pr-2">
                      <i
                        v-if="getCheckins().length > 0"
                        class="no no-check-bold text-white circle"
                        style="background-color: #22a06b; padding: 4px"
                      ></i>
                    </div>
                    <i
                      v-if="isUserAuthorizedBookingEditor && bookingDetails.status != 'CANCELLED'"
                      @click="bookingCheckin()"
                      class="no no-file-text-3 text-white bg-success circle"
                      type="button"
                      style="margin: 3px; padding: 4px"
                    ></i>
                  </span>
                </div>
                <div v-else class="text-center">
                  <div style="color: black; font-weight: 700; font-size: small">
                    Código QR da reserva
                  </div>

                  <qrcode-vue
                    v-if="qrCodeOrderUrl != undefined"
                    class="svg"
                    renderAs="svg"
                    :size="125"
                    :value="qrCodeOrderUrl"
                  >
                  </qrcode-vue>
                </div>
              </div>
            </div>
          </div>
          <!-- Fim Ticket 1 -->
        </div>

        <div v-if="!isLoading" class="infosarea">
          <h4 style="color: gray; font-weight: 600">Informações do pedido:</h4>

          <div class="infosidecard" style="font-size: 14px">
            <div class="text-black d-flex">
              Situação do pedido:
              <div
                class="pl-1"
                :style="`color: ${
                  bookingDetails.statusColor || 'rgb(33, 122, 159)'
                }`"
                style="font-weight: 600"
              >
                {{ bookingDetails.orderStatusText }}
              </div>
            </div>

            <div class="text-black d-flex">
              Criado por:
              <div class="pl-1">
                {{
                  bookingDetails.payload.costumer.name || 'nome não informado'
                }}
              </div>
            </div>
            <div class="text-black d-flex" v-if="isUserAuthorizedBookingEditor">
              CPF:
              <div class="pl-1">
                {{ bookingDetails.payload.costumer.cpf || 'CPF não informado' }}
              </div>
            </div>
            <div class="text-black d-flex" v-if="isUserAuthorizedBookingEditor">
              Telefone:
              <div class="pl-1">
                {{
                  bookingDetails.payload.costumer.phone.number ||
                  'Telefone não informado'
                }}
              </div>
            </div>

            <div class="text-black d-flex">
              Criado em:
              <div class="pl-1">
                {{ formattedDate(bookingDetails.payload.created_date) }}
              </div>
            </div>

            <div class="text-black d-flex">
              Última atualização:
              <div class="pl-1">
                {{ formattedDate(bookingDetails.payload.created_date) }}
              </div>
            </div>
          </div>

          <h4 class="pt-3" style="color: gray; font-weight: 600">
            Informações do pagamento:
          </h4>

          <div class="infosidecard" style="font-size: 14px">
            <div
              v-if="
                bookingDetails.payload.order != undefined &&
                Number(bookingDetails.payload.order.final_value) > 0
              "
            >
              <div class="text-black d-flex">
                Situação do pagamento:
                <div
                  class="pl-1"
                  :style="`color: ${
                    bookingDetails.statusColor || 'rgb(33, 122, 159)'
                  }`"
                  style="font-weight: 600"
                >
                  {{
                    bookingDetails.payload.payments.slice(-1)[0]
                      .payment_description != undefined &&
                    bookingDetails.payload.payments
                      .slice(-1)[0]
                      .payment_description.indexOf('cortesia') >= 0
                      ? 'cortesia'
                      : bookingDetails.paymentStatusText
                  }}
                </div>
              </div>

              <div class="text-black d-flex">
                Criado em:
                <div class="pl-1">
                  {{
                    formattedDate(
                      bookingDetails.payload.payments[0].payment_date
                    )
                  }}
                </div>
              </div>

              <div
                class="text-black d-flex"
                v-if="
                  this.bookingPaidStatusArray.indexOf(
                    this.bookingDetails.status
                      ? this.bookingDetails.status.toUpperCase()
                      : ''
                  ) >= 0
                "
              >
                Data de pagamento:
                <div class="pl-1">
                  {{
                    formattedDate(
                      bookingDetails.payload.payments[0].payment_date
                    )
                  }}
                </div>
              </div>

              <div
                class="text-black"
                v-if="
                  this.bookingPaidStatusArray.indexOf(
                    this.bookingDetails.status
                      ? this.bookingDetails.status.toUpperCase()
                      : ''
                  ) >= 0
                "
              >
                <span class="d-block w-100"> Pagamentos: </span>
                <ul style="list-style: none" class="d-block w-100 pl-3">
                  <li
                    v-for="(
                      payment, index
                    ) in this.bookingDetails.payload.payments.filter(
                      (p) => p.payment_value > 0
                    )"
                    :key="index"
                    v-bind="payment.paymentDescription"
                  >
                    R$
                    {{
                      Number(payment.payment_value)
                        .toFixed(2)
                        .toLocaleString('pt-BR')
                        .replace('.', ',')
                    }}
                    ({{ payment.payment_description }})
                  </li>
                </ul>
              </div>
              <div class="d-block w-100 pt-3">
                <template>
                  <!-- TODO fix qrcode generation -->
                  <b-button
                    v-if="false && isUserAuthorizedToPayLater"
                    @click="openModalPagamento()"
                    variant="primary"
                    class="pill"
                  >
                    Pagar online
                  </b-button>
                  <!--
                  <sub v-else :style="` color: ${bookingDetails.statusColor}`">
                    *prazo para pagamento expirado
                  </sub>
                -->
                  <b-button
                    v-if="isUserAuthorizedToSetCOD"
                    @click="openModalPagamentoLocal()"
                    variant="primary"
                    class="pill"
                  >
                    Marcar como paga
                  </b-button>
                </template>
              </div>
            </div>
            <div v-else class="text-black d-flex">
              <div class="pl-1">Reserva gratuita</div>
            </div>
          </div>

          <h4
            v-if="
              bookingDetails.payload.term &&
              $route.params.term_hash == bookingDetails.payload.term.hash
            "
            class="pt-3"
            style="color: gray; font-weight: 600"
          >
            Termos e condições
          </h4>
          <div
            v-if="
              (bookingDetails.payload.term &&
                $route.params.term_hash == bookingDetails.payload.term.hash) ||
              isUserAuthorizedBookingEditor
            "
            class="infosidecard w-100"
            style="font-size: 14px"
          >
            <div class="text-black">
              <div class="pl-1">
                <booking-term
                  mode="card"
                  :hash="
                    bookingDetails.payload.term
                      ? bookingDetails.payload.term.hash
                      : ''
                  "
                  :booking_code="$route.params.booking_code"
                  :term-date="
                    bookingDetails.payload.term
                      ? bookingDetails.payload.term.date
                      : ''
                  "
                  :show-header="false"
                  :show-footer="false"
                  :enable-signature-footer="false"
                />
                <a
                  class="d-flex text-primary mt-2"
                  style="cursor: pointer"
                  @click="
                    openTermModal(bookingDetails.payload.product.product_place)
                  "
                >
                </a>
              </div>
              <div class="text-black d-flex text-center">
                <b-button
                  variant="outline-primary"
                  @click="
                    openTermModal(bookingDetails.payload.product.product_place)
                  "
                  >ver termo</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="!isLoading && !isValidBooking">
        <div class="d-flex justify-content-center">
          <div class="ticketstatus" :style="'background-color:#AAAAAA'">
            <div class="ticket">
              <div
                class="ticketheaderborder"
                style="border-bottom: 2px #d93051"
              >
                <div
                  class="ticketheader"
                  style="
                    border-bottom-color: #d93051;
                    background: radial-gradient(
                          circle 3px at bottom left,
                          #d93051 85%,
                          white
                        )
                        bottom left,
                      radial-gradient(
                          circle 3px at bottom right,
                          #d93051 85%,
                          white
                        )
                        bottom right;
                    background-size: 50% 100%;
                    background-repeat: no-repeat;
                  "
                >
                  <div class="headerinfos">
                    <div class="iconarea">
                      <div class="ticketicon">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2984_25576)">
                            <path
                              d="M28.6667 29.3346H3.33333C1.496 29.3346 0 27.8386 0 26.0013V23.3346C0 22.9666 0.298667 22.668 0.666667 22.668H1.33333C2.804 22.668 4 21.472 4 20.0013C4 18.5306 2.804 17.3346 1.33333 17.3346H0.666667C0.298667 17.3346 0 17.036 0 16.668V14.0013C0 12.164 1.496 10.668 3.33333 10.668H28.6667C30.504 10.668 32 12.164 32 14.0013V16.668C32 17.036 31.7013 17.3346 31.3333 17.3346H30.6667C29.196 17.3346 28 18.5306 28 20.0013C28 20.7133 28.2773 21.3826 28.7813 21.8866C29.284 22.3906 29.9533 22.668 30.6653 22.668H31.332C31.7 22.668 31.9987 22.9666 31.9987 23.3346V26.0013C32 27.8386 30.504 29.3346 28.6667 29.3346ZM1.33333 24.0013V26.0013C1.33333 27.104 2.23067 28.0013 3.33333 28.0013H28.6667C29.7693 28.0013 30.6667 27.104 30.6667 26.0013V24.0013C29.5987 24.0013 28.5933 23.5853 27.8387 22.8306C27.0827 22.0746 26.6667 21.0693 26.6667 20.0013C26.6667 17.796 28.4613 16.0013 30.6667 16.0013V14.0013C30.6667 12.8986 29.7693 12.0013 28.6667 12.0013H3.33333C2.23067 12.0013 1.33333 12.8986 1.33333 14.0013V16.0013C3.53867 16.0013 5.33333 17.796 5.33333 20.0013C5.33333 22.2066 3.53867 24.0013 1.33333 24.0013Z"
                              fill="#131313"
                            />
                            <path
                              d="M11.3334 13.3346C10.9654 13.3346 10.6667 13.036 10.6667 12.668V11.3346C10.6667 10.9666 10.9654 10.668 11.3334 10.668C11.7014 10.668 12.0001 10.9666 12.0001 11.3346V12.668C12.0001 13.036 11.7014 13.3346 11.3334 13.3346Z"
                              fill="#131313"
                            />
                            <path
                              d="M11.3334 24.6161C10.9654 24.6161 10.6667 24.3174 10.6667 23.9494V21.6947C10.6667 21.3267 10.9654 21.0281 11.3334 21.0281C11.7014 21.0281 12.0001 21.3254 12.0001 21.6947V23.9507C12.0001 24.3187 11.7014 24.6161 11.3334 24.6161ZM11.3334 18.9761C10.9654 18.9761 10.6667 18.6774 10.6667 18.3094V16.0534C10.6667 15.6854 10.9654 15.3867 11.3334 15.3867C11.7014 15.3867 12.0001 15.6854 12.0001 16.0534V18.3094C12.0001 18.6774 11.7014 18.9761 11.3334 18.9761Z"
                              fill="#131313"
                            />
                            <path
                              d="M11.3334 29.3346C10.9654 29.3346 10.6667 29.036 10.6667 28.668V27.3346C10.6667 26.9666 10.9654 26.668 11.3334 26.668C11.7014 26.668 12.0001 26.9666 12.0001 27.3346V28.668C12.0001 29.036 11.7014 29.3346 11.3334 29.3346Z"
                              fill="#131313"
                            />
                            <path
                              d="M3.3334 11.9991C3.06273 11.9991 2.80806 11.8338 2.7094 11.5658C2.58006 11.2205 2.75473 10.8365 3.10006 10.7085L24.3001 2.79245C25.3307 2.40579 26.5414 2.98445 26.8934 4.02312L29.2974 11.1178C29.4147 11.4671 29.2281 11.8445 28.8801 11.9631C28.5347 12.0818 28.1534 11.8938 28.0347 11.5458L25.6307 4.45112C25.5134 4.10445 25.1107 3.91512 24.7654 4.04045L3.5654 11.9565C3.4894 11.9858 3.41073 11.9991 3.3334 11.9991Z"
                              fill="#131313"
                            />
                          </g>

                          <defs>
                            <clipPath id="clip0_2984_25576">
                              <rect width="32" height="32" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>

                      <div class="reservation-code align-items-center">
                        <div
                          style="
                            color: black;
                            font-weight: 600;
                            font-size: large;
                          "
                        >
                          {{ '#' + ORDER_UUID }}
                        </div>
                        <div
                          class="text-gray mt-0 ml-2"
                          style="font-size: small; line-height: 100%"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ticketfooter text-center">RESERVA NÃO ENCONTRADA</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CHANGE BOOKING DATE -->
    <b-modal
      v-if="showDateChangeModal"
      v-model="showDateChangeModal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      :size="'xl'"
    >
      <template #modal-header>
        <h4 align-v="start" class="border-bottom w-100 text-left pb-2">
          Alterar data da reserva #{{ bookingDetails.bookingCode }}
        </h4>

        <div class="text-right">
          <button
            @click.prevent="closeDateChangeModal()"
            type="button"
            class="close pb-2"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span>x</span>
          </button>
        </div>
      </template>

      <CalendarAlterBookingDate
        v-if="showDateChangeModal"
        :bookingDetails="bookingDetails"
        :PLACE_UUID="PLACE_UUID"
        :PRODUCT_UUID="PRODUCT_UUID"
        :showDateChangeModal="showDateChangeModal"
        @bookingDateUpdated="bookingDateUpdated"
        @setIsLoading="setIsLoading"
        @emitCloseDateChangeModal="closeDateChangeModal"
      >
      </CalendarAlterBookingDate>
    </b-modal>
    <!-- END MODAL CHANGE BOOKING DATE -->

    <!-- MODAL CHANGE BOOKING TICKETS -->
    <b-modal
      v-if="showBookingTicketModal"
      v-model="showBookingTicketModal"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      :size="'xl'"
    >
      <template #modal-header style="padding-bottom: 0">
        <h4 align-v="start" class="border-bottom w-100 text-left pb-2">
          Alterar ingressos da reserva #{{ bookingDetails.bookingCode }} |
          {{
            bookingDetails.payload.order != undefined
              ? Number(bookingDetails.payload.order.final_value).toLocaleString(
                  'pt-br',
                  { style: 'currency', currency: 'BRL' }
                )
              : '--'
          }}
        </h4>

        <div class="text-right">
          <button
            @click.prevent="closeBookingTicketsModal()"
            type="button"
            class="close pb-2"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span>x</span>
          </button>
        </div>
      </template>

      <ChangeBookingTickets
        v-if="showBookingTicketModal"
        :bookingDetails="bookingDetails"
        :PLACE_UUID="PLACE_UUID"
        :PRODUCT_UUID="PRODUCT_UUID"
        :showBookingTicketModal="showBookingTicketModal"
        @bookingTicketsUpdated="bookingTicketsUpdated"
        @setIsLoading="setIsLoading"
        @emitCloseBookingTicketsModal="closeBookingTicketsModal"
      >
      </ChangeBookingTickets>
    </b-modal>
    <!-- END MODAL CHANGE BOOKING TICKETS -->

    <!-- MODAL PICK AGENTS -->
    <AgentSelectorModal
      v-if="showAgentSelector"
      :showAgentSelector="showAgentSelector"
      :conductors="conductors"
      @closeAgentSelector="closeAgentSelector"
      @emitSelectedAgents="emitSelectedAgents"
    >
    </AgentSelectorModal>
    <!-- END MODAL PICK AGENTS -->

    <booking-vehicle-modal
      :visible="showVehicleSelector"
      :vehicles="slotVehicles"
      :selected="bookingVehicles"
      :total-pax="bookingTotalPax"
      :saving="savingVehicles"
      @close="closeVehicleSelector"
      @confirm="emitSelectedVehicles"
    />

    <!-- MODAL SEE AGENT INFO -->
    <b-modal
      v-if="showBookingTicketModal"
      v-model="openAgentCard"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      :size="'xl'"
    >
      <template v-if="currentAgentData != null" #modal-header>
        <h2 align-v="start" class="card-header w-100 text-left"></h2>

        <div class="text-right">
          <button
            @click.prevent="closeAgentCard"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span @click.prevent="closeAgentCard">x</span>
          </button>
        </div>
      </template>

      <agent-card
        class="mt-6"
        v-if="openAgentCard"
        v-bind="currentAgentData"
        :agent="currentAgentData.agent"
        :formations="currentAgentData.formations"
        :city="currentAgentData.city"
        :place="currentAgentData.place"
        :mainPlaceAgentData="currentAgentData.mainPlaceAgentData"
        :toggleQR="true"
      />
    </b-modal>
    <!-- END MODAL SEE AGENT INFO -->

    <!-- MODAL PAYMENT -->
    <PagamentoModal
      v-if="isModalPagamentoOpen"
      :isPaymentLater="false"
      :isModalPagamentoOpen="isModalPagamentoOpen"
      :PAYMENT_STATUS="'UNPAID'"
      @closePagamentoModal="closePagamentoModal"
    >
    </PagamentoModal>
    <!-- END MODAL PAYMENT -->

    <!-- MODAL LOCAL PAYMENT -->
    <LocalPaymentModal
      v-if="isModalPagamentoLocalOpen"
      :PAYMENT_STATUS="'UNPAID'"
      @closePagamentoModal="closeModalPagamentoLocal"
      @confirmLocalPayment="confirmLocalPayment"
    >
    </LocalPaymentModal>
    <!-- END MODAL LOCAL PAYMENT -->

    <b-sidebar
      :visible="showTermPanel"
      no-header-close
      right
      backdrop
      no-close-on-backdrop
      width="480px"
      @change="onTermSidebarVisibilityChange"
    >
      <template #header>
        <b-row align-v="center" class="w-100 mt-2">
          <b-col align-h="start" cols="2">
            <button
              @click.prevent="closeTermPanel"
              type="button"
              class="close"
              aria-label="Fechar"
            >
              <span class="no no-e-remove"></span>
            </button>
          </b-col>
        </b-row>
      </template>
      <div class="booking-term-sidebar-body pr-4 pl-4">
        <booking-term
          v-if="showTermPanel"
          :booking_code="
            $route.params.booking_code || bookingDetails.bookingCode
          "
          :show-header="false"
          :show-footer="true"
          :enable-signature-footer="false"
          @close="closeTermPanel"
          @sign="signTerm"
        />
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import AgentSelectorModal from '../Agents/AgentSelectorModal.vue'
import BookingVehicleModal from './BookingVehicleModal.vue'
import nodeService from '@/services/nodejs'
import AgentCard from '../Agents/AgentCard.vue'
import CalendarAlterBookingDate from '../ReservaExpressa/CalendarChangeBookingDate.vue'
import ChangeBookingTickets from '../ReservaExpressa/ChangeBookingTickets.vue'
import PagamentoModal from '../ReservaExpressa/PagamentoModal.vue'
import LocalPaymentModal from '../ReservaExpressa/LocalPaymentModal.vue'
import BookingTerm from '../ReservaExpressa/BookingTerm.vue'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import {
  hasModule,
  formatAgentData,
  isSystemAdmin,
} from '../../store/utils/users'
import { mapGetters, mapActions } from 'vuex'
import { blockDriverUuids, extraDriverCount } from './vehicleAllocation'
import qrcodeVue from 'qrcode.vue'
import moment from 'moment-timezone'
import swal from 'sweetalert2'
import { formatDate } from '../../store/utils/general'
import store from '@/store'
import { computed } from 'vue'

export default {
  name: 'DetalhesReserva',

  components: {
    qrcodeVue,
    AgentSelectorModal,
    BookingVehicleModal,
    AgentCard,
    CalendarAlterBookingDate,
    ChangeBookingTickets,
    ModalLoading,
    PagamentoModal,
    LocalPaymentModal,
    BookingTerm,
  },

  props: {
    bookingCode: {
      type: String,
      default: () => '',
    },

    DEVICE: {
      type: String,
      default: () => '' || undefined,
    },

    startDate: {
      type: String,
      default: () => '',
    },

    endDate: {
      type: String,
      default: () => '',
    },
  },

  provide() {
    return {
      isOnline: computed(() => this.isOnline),
    }
  },

  data() {
    return {
      bookingDetailsInitial: {},
      showAgentSelector: false,
      showVehicleSelector: false,
      savingVehicles: false,
      removingVehicleUuid: null,
      removingAgentUuid: null,
      showDateChangeModal: false,
      showBookingTicketModal: false,
      isModalPagamentoLocalOpen: false,
      isModalPagamentoOpen: false,
      showTermPanel: false,
      termPlaceUUID: '',
      isOnline: navigator.onLine,
      chosenAgents: [],
      currentAgentData: { agent: { id: 0, name: '' } },
      currentPOIData: [],
      canPayLater: false,
      openAgentCard: false,
      isLoading: false,
      requiredFields: {
        active: { label: 'active', public_label: 'Ativo', type: 'checkbox' },
        changed: {
          label: 'changed',
          public_label: 'Última alteração',
          type: 'hidden_config',
        },
        birthday: {
          label: 'birthday',
          public_label: 'Data de Anivesário',
          type: 'date',
        },
        blodtype: {
          label: 'blodtype',
          public_label: 'Tipo Sanguíneo',
          type: 'select',
          options: ['A+', 'A-', 'AB+', 'AB-', 'B+', 'B-', 'O+', 'O-'],
        },
        mobile: { label: 'mobile', public_label: 'Celular', type: 'text' },
        cnh: {
          label: 'cnh',
          public_label: 'CNH',
          type: 'select',
          options: ['A', 'AB', 'AD', 'AE', 'B', 'BC', 'D', 'E'],
        },
        languages: {
          label: 'languages',
          public_label: 'Outros Idiomas',
          type: 'selectmultiple',
          multiple: true,
          options: {
            german: 'german:Alemão',
            spanish: 'spanish:Espanhol',
            french: 'french:Francês',
            hebrew: 'hebrew:Hebráico',
            english: 'english:Inglês',
            italian: 'italian:Italiano',
            japanese: 'japanese:Japonês',
            others: 'others:Outros',
          },
        },
      },
    }
  },

  watch: {
    bookingDetails(newVal, oldVal) {
      let productUUID =
        oldVal && oldVal.productUuid
          ? oldVal.productUuid
          : newVal && newVal.productUuid
          ? newVal.productUuid
          : ''
      if (productUUID) {
        this.getPOIByUUID({ PRODUCT_UUID: productUUID })
          .then((response) => {
            this.currentPOIData = response
            this.checkCanPayLater()
            if (
              this.$route.params.term_hash &&
              this.$route.params.booking_code
            ) {
              this.openTermModal(this.bookingDetails.placeUuid)
            }
          })
          .catch((error) => {
            console.error('getPOIByUUID error', error)
          })
      }
    },
  },

  computed: {
    ...mapGetters('auth', {
      user: 'user',
      place: 'getPlace',
      params: 'params',
      roles: 'getRules',
    }),

    ...mapGetters('operacao', {
      bookingFromRoute: 'getBookingDetails',
      bookingPaidStatusArray: 'getBookingPaidStatusArray',
      billItemDetails: 'getBillItemDetails',
    }),

    ...mapGetters('agent', {
      agents: 'getAgents',
    }),

    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    isDetaisInModal() {
      return this.bookingCode != ''
    },

    qrCodeOrderUrl() {
      return (
        window.location.origin +
        '/booking-details/' +
        this.bookingDetails.bookingCode
      )
    },

    bookingDetails() {
      if (this.bookingFromRoute[0] != undefined) {
        var details = []
        details = this.bookingFromRoute.map(function (value, index) {
          value.payload =
            typeof value.payload == 'string'
              ? JSON.parse(value.payload)
              : value.payload
          return value
        })[0]

        this.bookingDetailsInitial =
          details &&
          (details.bookingCode == this.ORDER_UUID ||
            details.hash == this.ORDER_UUID)
            ? details
            : {
                payload: { product: { uuid: '' }, costumer: { name: '' } },
                status: 'UNPAID',
              }

        return this.bookingDetailsInitial
      } else {
        return this.bookingDetailsInitial
      }
    },

    ORDER_UUID() {
      let orderUUID =
        this.$route.params.booking_code == undefined
          ? this.bookingCode
          : this.$route.params.booking_code
      return orderUUID.replace('.png', '')
    },

    PLACE_UUID() {
      return this.place.uuid || this.user.placeUuid
    },

    PRODUCT_UUID() {
      return this.bookingDetails.productUuid
    },

    bookingTickets() {
      return this.bookingDetails.payload.items
    },

    isBookingValid() {
      if (
        this.bookingDetails.bookingCode &&
        (this.bookingDetails.bookingCode == this.ORDER_UUID ||
          this.bookingDetails.hash == this.ORDER_UUID) &&
        (this.bookingFromRoute[0].bookingCode == this.ORDER_UUID ||
          this.bookingFromRoute[0].hash == this.ORDER_UUID)
      ) {
        return true
      }
      return false
    },

    bookingStatus() {
      return this.bookingDetails && this.bookingDetails.status
        ? String(this.bookingDetails.status).toUpperCase()
        : ''
    },

    isQuotationBooking() {
      return this.bookingStatus === 'UNPAID'
    },

    isEditableBookingStatus() {
      const extraStatus = ['CANCELLED'].concat(this.bookingPaidStatusArray)
      return extraStatus.indexOf(this.bookingStatus) >= 0
    },

    hasBookingEditorPermission() {
      if (isSystemAdmin(this.roles)) {
        return true
      }

      const poiIndex = this.poisList.findIndex(
        (p) => p.uuid == this.bookingDetails.productUuid
      )
      //o produto pertence ao meu place
      //o usuário tem permissão para gerir reservas
      return hasModule('enable_local_agent') && poiIndex >= 0
    },

    isUserAuthorizedBookingEditor() {
      if (!this.isEditableBookingStatus) return false
      return this.hasBookingEditorPermission
    },

    // Cotação entra no menu do cabeçalho (data, ingressos, cancelar).
    canShowBookingActions() {
      if (!this.hasBookingEditorPermission) return false
      return this.isUserAuthorizedBookingEditor || this.isQuotationBooking
    },

    // Cotação não recebe veículo nem condutor.
    canAssignResourcesAndConductors() {
      return this.isUserAuthorizedBookingEditor && !this.isQuotationBooking
    },

    /**
     * determina se a reserva pode ser paga online a partir de um novo QRCode
     */
    isUserAuthorizedToPayLater() {
      // needs to be unpaid and not cancelled
      if (
        this.bookingPaidStatusArray.indexOf(
          this.bookingDetails.status
            ? this.bookingDetails.status.toUpperCase()
            : ''
        ) >= 0
      ) {
        return false
      }

      if (
        this.bookingDetails.status
          ? this.bookingDetails.status.toUpperCase()
          : '' == 'CANCELLED'
      ) {
        return false
      }

      return this.canPayLater === true
    },

    isValidBooking() {
      let isvalid =
        this.bookingDetailsInitial &&
        this.bookingDetailsInitial.payload != undefined &&
        this.bookingDetailsInitial.payload.hash != undefined
      return isvalid
    },
    /**
     * determina se o usuário logado pode setar a reserva com "paga no local"
     */
    isUserAuthorizedToSetCOD() {
      const poiIndex = this.poisList.findIndex(
        (p) => p.uuid == this.bookingDetails.productUuid
      )
      return (
        poiIndex >= 0 &&
        this.canPayLater === true &&
        this.user.placeName != undefined &&
        this.user.placeName.toLowerCase().indexOf('baixio') < 0
      ) //TODO: redefinir regra de confirmação de pagamento
    },

    bookingVehicles() {
      const payload = this.bookingDetails && this.bookingDetails.payload
      const stored = payload && (payload.vehicles || payload.vehicle)
      const list = Array.isArray(stored) ? stored : []
      return list
        .filter((item) => item && item.active !== false)
        .map((item) => ({ ...this.normalizeVehicle(item), pax: item.pax }))
        .filter((item) => item.uuid || item.name)
    },

    // Mesma conta do totalPax da API, que valida a soma dos pax dos veículos
    // Lugares (mesma conta do bookingSeats da API): pessoas vendidas + condutores
    // da reserva que não dirigem nenhum carro do horário
    bookingTotalPax() {
      const payload = this.bookingDetails && this.bookingDetails.payload
      const people = ((payload && payload.items) || []).reduce(
        (sum, item) => sum + (Number(item.quantity) || 0),
        0
      )
      return (
        people +
        extraDriverCount(
          { agents: (payload && payload.agents) || [] },
          blockDriverUuids(
            this.slotVehicles.map((vehicle) => ({ driver: vehicle.driver }))
          )
        )
      )
    },

    slotVehicles() {
      const details = this.bookingDetails
      const productUuid = details && details.productUuid
      const bookingDate =
        details && details.payload && details.payload.booking_date
      if (!productUuid || !bookingDate) return []

      const poi = (this.poisList || []).find((item) => item.uuid == productUuid)
      if (!poi) return []

      const date = moment(bookingDate)
      if (!date.isValid()) return []

      return this.resourcesForBookingSlot(
        poi,
        date.format('YYYY-MM-DD'),
        date.format('HH:mm')
      )
    },

    conductors() {
      if (this.bookingDetails) {
        let presentAgents =
          this.bookingDetails.payload.agents &&
          this.bookingDetails.payload.agents.length > 0
            ? this.bookingDetails.payload.agents
            : []
        let agentKeys = []
        let agents = [...presentAgents, ...this.chosenAgents]
        this.chosenAgents = []

        // REMOVING DUPLICATES
        agents = agents.filter(
          (agent_1, index, agents_array) =>
            agents_array.findIndex(
              (agent_2) => JSON.stringify(agent_2) == JSON.stringify(agent_1)
            ) == index
        )

        agents.filter((agent) => {
          if (agentKeys[agent.uuid] == undefined) {
            agentKeys[agent.uuid] = 1
            return true
          }
          return false
        })

        return agents
      } else {
        return []
      }
    },
    isCurrentUserSystemAdmin() {
      return isSystemAdmin(this.roles)
    },
  },

  methods: {
    ...mapActions('operacao', [
      'fetchBookingByUUID',
      'fetchBillItemsByUUID',
      'resetBookingDetails',
      'operationStoreCommit',
    ]),

    ...mapActions('booking', [
      'createLaterExpressBooking',
      'saveLocalPayments',
    ]),

    ...mapActions('agent', [
      'addBookingAgent',
      'removeBookingAgent',
      'checkExpressBooking',
      'cancelExpressBooking',
      'getAgentByUUID',
    ]),

    ...mapActions('product', ['fetchPOIs', 'getPOIByUUID']),

    formattedDate(date, format, tz) {
      return formatDate(date, format, tz)
    },

    openTermModal(place_uuid) {
      this.termPlaceUUID = place_uuid || ''
      this.showTermPanel = true
    },

    closeTermPanel() {
      this.showTermPanel = false
      this.termPlaceUUID = ''
    },

    onTermSidebarVisibilityChange(visible) {
      if (!visible) {
        this.closeTermPanel()
      }
    },
    getPlaceAgentXFields() {
      return this.params.AgentXFields
    },
    signTerm(payload) {
      this.closeTermPanel()
      this.$notify({
        message: 'Termo assinado com sucesso.',
        duration: 3000,
        type: 'success',
      })
      this.isLoading = true
      setTimeout(() => {
        window.document.location.reload()
      }, 2000)
    },

    async loadPois() {
      await this.fetchPOIs({
        PLACE_UUID: this.PLACE_UUID || '',
        PRODUCT_UUID: '',
      })
    },

    updateOnlineStatus(event) {
      this.isOnline = event.type == 'online'
    },

    visitorsAmount() {
      const items = this.bookingDetails.payload.items
      if (items && items.length > 0) {
        let amount =
          items.reduce((prev, curr) => {
            return prev + (Number(curr.quantity) || 0)
          }, 0) || 0
        return amount == 1 ? amount + ' visitante' : amount + ' visitantes'
      }

      return '--'
    },

    ticketResume(ticket) {
      var ticketTitle = ticket.title.toLowerCase().split('-')[0]
      return `${ticket.quantity} * ${ticketTitle} (R$ ${(
        ticket.unit_price * ticket.quantity
      )
        .toFixed(2)
        .replace('.', ',')})`
    },

    disableAfterNextMonthFifthBussinessDay() {
      let month = moment(this.bookingDetails.payload.booking_date).month() // NEXT MONTH
      let year =
        month < 11
          ? moment(this.bookingDetails.payload.booking_date).year()
          : moment(this.bookingDetails.payload.booking_date).add(1, 'Y').year() // CURRENT YEAR UNTIL DECEMBER (11) OR NEXT IF WE ARE ON DECEMBER
      let nextMonthEnd = moment(this.bookingDetails.payload.booking_date)
        .add(1, 'M')
        .endOf('month')
        .hour(23)
        .minute(59)
        .second(59)

      month = nextMonthEnd.month()
      year = nextMonthEnd.year()

      // Array of dates from the first to the last day of next month
      let bussinessDates = new Array(nextMonthEnd.date())
        .fill(0)
        .map(function (value, index) {
          return moment([year, month, index + 1])
            .hour(23)
            .minute(59)
            .second(59)
        })

      // Filtering sundays and saturdays
      bussinessDates = bussinessDates.filter(
        (date) => date.weekday() >= 1 && date.weekday() <= 5
      )

      // Returning if today is after the 5th bussiness day of next month
      if (bussinessDates.length > 2) {
        return moment().isAfter(bussinessDates[2])
      }

      return false
    },

    getCheckins() {
      var checkins = []
      var bookingCheckins =
        this.bookingDetails.payload.checkins != undefined
          ? this.bookingDetails.payload.checkins
          : []

      if (
        this.billItemDetails.checkin != undefined &&
        this.billItemDetails.checkin.list.length > 0
      ) {
        // FILTER THE NEW CHECKIN FROM billItemDetails (most updated array), VERIFIYNG IF THE NEW ONE IS NOT PRESENT ON booking.payload.checkins
        // ITS LIKE VENN'S DIAGRAM, i.e, (billItemDetails - booking.payload.checkins)
        checkins = this.billItemDetails.checkin.list.filter(
          (checkinList) =>
            !bookingCheckins.some(
              (checkinPayload) => checkinList.date === checkinPayload.date
            )
        )
      } else {
        checkins = bookingCheckins
      }

      return checkins
    },

    bookingCancelation() {
      swal
        .fire({
          text: 'Cancelar esta reserva?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, cancelar',
          confirmButtonColor: '#D93051',
          cancelButtonText: 'Não',
          reverseButtons: true,
          cancelButtonColor: 'secondary',
          type: 'default',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.saveBookingDetailsCancel()
          }
        })
    },

    async saveBookingDetailsCancel() {
      let bookingHash = this.bookingDetails.hash
      this.isLoading = true
      try {
        // Cada carro ativo sai pelo uuid do recurso. Lista vazia no set é recusada.
        for (let index = 0; index < this.bookingVehicles.length; index++) {
          const vehicle = this.bookingVehicles[index]
          if (!vehicle.uuid) continue
          const vehiclesPayload = { hash: bookingHash, uuid: vehicle.uuid }
          try {
            await nodeService.postRemoveBookingVehicle(vehiclesPayload)
          } catch (error) {
            const apiMessage = error && error.data && error.data.message
            console.error('booking remove vehicle failed', {
              hash: vehiclesPayload.hash,
              uuid: vehiclesPayload.uuid,
              error,
            })
            this.$notify({
              message: apiMessage
                ? `Não foi possível remover o veículo da reserva: ${apiMessage}`
                : 'Não foi possível remover o veículo da reserva.',
              duration: 8000,
              type: 'danger',
            })
            return
          }
        }

        await this.cancelExpressBooking({ hash: bookingHash })
        await this.resetBookingDetails()
        await this.reloadBookingDetails('reserva cancelada!')
      } catch (error) {
        this.$notify({
          message: 'Erro ao cancelar reserva!',
          duration: 6000,
          type: 'error',
        })
      } finally {
        this.isLoading = false
      }
    },

    bookingCheckin() {
      swal
        .fire({
          text: 'Realizar checkin?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          confirmButtonClass: 'btn btn-primary',
          confirmButtonColor: '#22A06B',
          cancelButtonText: 'Fechar',
          reverseButtons: true,
          cancelButtonColor: 'secondary',
          type: 'default',
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.saveBookingDetailsCheckin()
          }
        })
    },

    async saveBookingDetailsCheckin() {
      this.setIsLoading(true)
      this.chosenAgents = []
      this.resetBookingDetails()
      await this.checkExpressBooking({ hash: this.bookingDetails.hash })
        .then((response) => {})
        .catch((error) => {
          console.error('erro ao salvar reservas', error)
        })
      this.reloadBookingDetails('checkin realizado!')
    },

    async reloadBookingDetails(notifyMessage) {
      // 1) Embutido no BookingList (ou outro pai): pede reload da lista
      if (this.isDetaisInModal) {
        this.$emit('emitUpdateBookingList')
      }

      // 2) Atualiza os detalhes exibidos no modal / página
      await this.fetchBookingByUUID(this.ORDER_UUID)

      if (this.startDate && this.endDate) {
        await this.fetchBillItemsByUUID({
          startDate: this.startDate,
          endDate: this.endDate,
          useFakeData: false,
          code: this.ORDER_UUID,
          daysInternval: 1,
          operation_request: false,
        })
      }

      this.$notify({ message: notifyMessage, duration: 6000, type: 'success' })

      this.setIsLoading(false)
      // Página isolada: /booking-details/:booking_code
      if (!this.isDetaisInModal) {
        setTimeout(() => {
          window.document.location.reload()
        }, 2000)
      }

      return true
    },

    goToSite() {
      const URL_LOJA = process.env.VUE_APP_LARAVEL_URL
      window.open(URL_LOJA, '_self')
    },

    normalizeVehicle(item) {
      if (!item) return {}
      return {
        uuid: item.uuid || item.resource_uuid || '',
        name: item.name || item.resource_name || '',
        plate: item.plate || item.resource_plate || '',
        type: item.type || item.resource_type || 'vehicle',
        capacity:
          item.capacity != null ? item.capacity : item.resource_capacity,
        category: item.category || item.resource_category || '',
        driver: item.driver || null,
      }
    },

    vehicleNameByUuid(uuid) {
      const vehicle =
        this.slotVehicles.find((item) => item.uuid === uuid) ||
        this.bookingVehicles.find((item) => item.uuid === uuid)
      return vehicle ? vehicle.name : 'carro'
    },

    parseResourceObject(value) {
      if (!value) return null
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value)
          return parsed && typeof parsed === 'object' ? parsed : null
        } catch (error) {
          return null
        }
      }
      return typeof value === 'object' ? value : null
    },

    normalizeTimeKey(start) {
      if (start == null || start === '') return ''
      const parsed = moment(String(start), ['HH:mm:ss', 'HH:mm', 'H:mm'], true)
      if (!parsed.isValid()) return ''
      return parsed.format('HH:mm')
    },

    resourcesForBookingSlot(poi, dateKey, timeKey) {
      const resources = this.parseResourceObject(poi && poi.resources)
      const monthKey = String(dateKey || '').slice(0, 7)
      const month = resources && resources[monthKey]
      if (!month || typeof month !== 'object') return []

      const targetTime = this.normalizeTimeKey(timeKey)
      const found = []
      Object.entries(month).forEach(([key, value]) => {
        if (!Array.isArray(value)) return
        const separator = String(key).indexOf(' ')
        const datePart = separator >= 0 ? key.slice(0, separator) : ''
        const timePart = separator >= 0 ? key.slice(separator + 1) : ''
        if (datePart !== dateKey) return
        if (this.normalizeTimeKey(timePart) !== targetTime) return
        value.forEach((item) => {
          const vehicle = this.normalizeVehicle(item)
          if (vehicle.uuid || vehicle.name) found.push(vehicle)
        })
      })
      return found
    },

    openVehicleSelectorModal() {
      if (!this.canAssignResourcesAndConductors) return
      this.showVehicleSelector = true
    },

    closeVehicleSelector() {
      if (this.savingVehicles) return
      this.showVehicleSelector = false
    },

    async emitSelectedVehicles(vehicles) {
      if (!this.canAssignResourcesAndConductors) return
      const selected = (vehicles || []).filter((vehicle) => vehicle && vehicle.uuid)
      if (!selected.length) {
        this.$notify({
          message: 'Selecione ao menos um veículo.',
          duration: 5000,
          type: 'warning',
        })
        return
      }

      // Alocação completa da reserva: carros fora da lista são desativados (ADR 001)
      const payload = {
        hash: this.bookingDetails.hash,
        vehicles: selected.map((vehicle) => ({
          resource_uuid: vehicle.uuid,
          pax: vehicle.pax,
        })),
      }

      this.savingVehicles = true
      try {
        await nodeService.postSetBookingVehicles(payload)
        this.showVehicleSelector = false
        await this.resetBookingDetails()
        await this.reloadBookingDetails('Veículos da reserva atualizados!')
      } catch (error) {
        // nodeApi3 rejeita com o response; a mensagem de validação vem em data
        const apiMessage = error && error.data && error.data.message
        console.error('booking set vehicles failed', {
          hash: payload.hash,
          vehicles: payload.vehicles,
          error,
        })
        this.$notify({
          message: apiMessage
            ? `Não foi possível salvar os veículos da reserva: ${apiMessage}`
            : 'Não foi possível salvar os veículos da reserva.',
          duration: 8000,
          type: 'danger',
        })
      } finally {
        this.savingVehicles = false
      }
    },

    openAgentSelectorModal() {
      if (!this.canAssignResourcesAndConductors) return
      this.showAgentSelector = true
      this.$router
        .push({ path: this.$route.fullPath, hash: '#booking-agent' })
        .catch((e) => {
          console.warn('NavigationDuplicated prevented')
        })
    },

    closeAgentSelector() {
      this.showAgentSelector = false
      this.$router
        .push({ path: this.$route.fullPath, hash: '#booking' })
        .catch((e) => {
          console.warn('NavigationDuplicated prevented')
        })
    },

    changeBookingDate() {
      this.showDateChangeModal = true
      this.$router
        .push({ path: this.$route.fullPath, hash: '#booking-date-change' })
        .catch((e) => {
          console.warn('NavigationDuplicated prevented')
        })
    },

    closeDateChangeModal() {
      this.showDateChangeModal = false
      this.$router
        .push({ path: this.$route.fullPath, hash: '#booking' })
        .catch((e) => {
          console.warn('NavigationDuplicated prevented')
        })
    },

    changeBookingTicketsModal() {
      this.showBookingTicketModal = true
      this.$router
        .push({ path: this.$route.fullPath, hash: '#booking-ticket-change' })
        .catch((e) => {
          console.warn('NavigationDuplicated prevented')
        })
    },

    closeBookingTicketsModal() {
      this.showBookingTicketModal = false
      this.$router
        .push({ path: this.$route.fullPath, hash: '#booking' })
        .catch((e) => {
          console.warn('NavigationDuplicated prevented')
        })
    },
    setIsLoading(value) {
      this.isLoading = value
    },
    async bookingDateUpdated() {
      this.closeDateChangeModal()
      this.resetBookingDetails()
      this.reloadBookingDetails('data da reserva modificada!')
    },

    async bookingTicketsUpdated() {
      this.closeBookingTicketsModal()
      this.resetBookingDetails()
      this.reloadBookingDetails('ingressos da reserva modificados!')
    },

    handleBackDetails(e) {
      if (this.showAgentSelector) {
        this.closeAgentSelector()
        return
      }
      if (this.showVehicleSelector) {
        this.closeVehicleSelector()
        return
      }
      if (this.showDateChangeModal) {
        this.closeDateChangeModal()
        return
      }
      if (this.openAgentCard) {
        this.closeAgentCard()
        return
      } else {
        this.$router.back()
        return
      }
    },

    // Remove na API primeiro e só depois atualiza a tela: antes o item sumia na
    // hora e, se a API falhasse (sem aviso), voltava no próximo recarregamento
    async removeVehicle(vehicle) {
      if (this.removingVehicleUuid) return
      this.removingVehicleUuid = vehicle.uuid
      const payload = { hash: this.bookingDetails.hash, uuid: vehicle.uuid }
      try {
        await nodeService.postRemoveBookingVehicle(payload)
      } catch (error) {
        this.removingVehicleUuid = null
        this.notifyBookingActionError('remover o veículo', payload, error)
        return
      }
      await this.reloadAfterBookingAction('Veículo removido!')
      this.removingVehicleUuid = null
    },

    async removeAgent(agent) {
      if (this.removingAgentUuid) return
      this.removingAgentUuid = agent.uuid
      const payload = { hash: this.bookingDetails.hash, uuid: agent.uuid }
      try {
        await this.removeBookingAgent(payload)
      } catch (error) {
        this.removingAgentUuid = null
        this.notifyBookingActionError('remover o condutor', payload, error)
        return
      }
      await this.reloadAfterBookingAction('Condutor removido!')
      this.removingAgentUuid = null
    },

    async reloadAfterBookingAction(message) {
      await this.resetBookingDetails()
      if (this.isDetaisInModal) {
        await this.reloadBookingDetails(message)
        return
      }
      await this.fetchBookingByUUID(this.ORDER_UUID)
      this.$notify({ message, duration: 6000, type: 'success' })
    },

    notifyBookingActionError(action, payload, error) {
      // nodeApi3 rejeita com o response (mensagem em data) ou, sem response
      // (timeout/rede), com o erro do axios
      const apiMessage =
        (error && error.data && error.data.message) ||
        (error && error.code === 'ECONNABORTED' && 'tempo esgotado')
      console.error('booking action failed', { action, ...payload, error })
      this.$notify({
        message: apiMessage
          ? `Não foi possível ${action}: ${apiMessage}`
          : `Não foi possível ${action}.`,
        duration: 8000,
        type: 'danger',
      })
    },

    async emitSelectedAgents(agents) {
      if (!this.canAssignResourcesAndConductors) return
      this.chosenAgents = agents
        .map(function (value, index) {
          return {
            active: value.selected,
            name: value.name,
            uuid: value.uuid,
            nickname: value.nickname,
            place: value.Place.name,
          }
        })
        .filter((a) => a.active)

      const payload = {
        hash: this.bookingDetails.hash,
        agents: this.chosenAgents,
      }

      if (payload.agents.length > 0) {
        try {
          await this.addBookingAgent(payload)
        } catch (error) {
          this.notifyBookingActionError('adicionar o condutor', payload, error)
          return
        }
        await this.resetBookingDetails()

        let conductors = payload.agents.length > 1 ? 'condutores' : 'condutor'
        this.reloadBookingDetails(`Sucesso ao adicionar ${conductors}!`)
      }
    },

    closeAgentCard() {
      this.openAgentCard = false
      this.currentAgentData = {}
      this.$router
        .push({ path: this.$route.fullPath, hash: '#booking' })
        .catch((e) => {
          console.warn('NavigationDuplicated prevented')
        })
    },

    async handleView(agentUuid) {
      await this.getAgentByUUID(agentUuid)
        .then((rsp) => {
          this.currentAgentData = formatAgentData(
            rsp.view,
            0,
            this.getPlaceAgentXFields(),
            { currentUserPois: this.poisList },
            this.requiredFields
          )

          this.openAgentCard = true
          this.$router
            .push({ path: this.$route.fullPath, hash: '#booking-agent-card' })
            .catch((e) => {
              console.warn('NavigationDuplicated prevented')
            })
        })
        .catch((error) => {
          swal.fire({
            text: 'Nenhuma informação encontrada! Edite o perfil para inserir informações',
            buttonClass: 'btn btn-error',
            icon: 'warning',
          })
        })
    },

    closePagamentoModal() {
      this.isModalPagamentoOpen = false
    },

    closeModalPagamentoLocal() {
      this.isModalPagamentoLocalOpen = false
    },

    async confirmLocalPayment(localPayments) {
      this.isModalPagamentoLocalOpen = false
      const hash = this.bookingDetails.payload.hash
      this.isLoading = true
      await this.saveLocalPayments({ hash: hash, payments: localPayments })
        .then((result) => {
          this.resetBookingDetails()
          this.fetchBookingByUUID(this.ORDER_UUID).then(() => {
            setTimeout(() => {
              this.isLoading = false
            }, 1000)
            this.$notify({
              message: 'Pagamento local registrado com sucesso!',
              duration: 6000,
              type: 'success',
            })
          })
        })
        .catch((err) => {
          console.error('ERROR >>>', err)
        })
    },

    openModalPagamento() {
      if (this.canPayLater) {
        this.isModalPagamentoOpen = true
        const form = { booking_code: this.ORDER_UUID }
        this.createLaterExpressBooking(form)
        this.$router
          .push({ path: this.$route.fullPath, hash: '#booking-payment' })
          .catch((e) => {
            console.warn('NavigationDuplicated prevented')
          })
      }
    },
    openModalPagamentoLocal() {
      this.isModalPagamentoLocalOpen = true
      if (this.canPayLater) {
        // const form = { booking_code: this.ORDER_UUID, }
        // this.createLaterExpressBooking(form)
        // this.$router.push({ path: this.$route.fullPath, hash: "#booking-payment" }).catch((e)=>{console.warn('NavigationDuplicated prevented')});
      }
    },

    async checkCanPayLater() {
      var days_in_advance = 0
      let special_price = null
      let poiIndex = this.poisList.findIndex((p) => p.uuid == this.PRODUCT_UUID)
      let guestPoiIndex = -1
      if (this.currentPOIData[0] == undefined) {
        return false
      }
      if (poiIndex < 0) {
        guestPoiIndex = [...this.poisList, ...this.currentPOIData].findIndex(
          (p) => p.uuid == this.PRODUCT_UUID
        )
      }

      if (poiIndex >= 0 || guestPoiIndex >= 0) {
        let index = poiIndex >= 0 ? poiIndex : guestPoiIndex
        special_price = [...this.poisList, ...this.currentPOIData][
          index
        ].special_prices[0].find(
          (ticket) => ticket.slug == this.bookingDetails.payload.booking_slug
        )
      }

      if (special_price && special_price.days_in_advance != undefined) {
        days_in_advance = special_price.days_in_advance
      } else {
        days_in_advance = 0
      }

      var future_date = moment(this.bookingDetails.booking_date).subtract(
        days_in_advance,
        'day'
      )
      let canPayLater = true

      if (
        this.bookingDetails.payload &&
        this.bookingDetails.payload.cod_booking
      ) {
        canPayLater = false
      }
      if (!moment().isBefore(future_date) && poiIndex < 0) {
        canPayLater = false
      }

      if (
        (this.bookingDetails.payload &&
          Number(this.bookingDetails.payload.order.final_value)) == 0
      ) {
        canPayLater = false
      }

      if (
        this.bookingDetails.status
          ? this.bookingDetails.status.toUpperCase()
          : '' != 'UNPAID' && this.bookingDetails.status
          ? this.bookingDetails.status.toUpperCase()
          : '' != 'PENDING'
      ) {
        canPayLater = false
      }
      // }
      this.canPayLater = canPayLater
    },

    getCheckinDetails(booking) {
      let ticketDetails = ''
      booking.checkins.forEach((item) => {
        ticketDetails += `
          <div class="d-flex ml-3" style="font-size: small;">
          ${moment.utc(item.date).local().format('DD/MM/YYYY, H:mm')}
            <div class="pl-1  d-inline" style="font-size: small; color:darkgray">(${
              item.operator || item.name
            })</div>
          </div>
          `
      })
      return ticketDetails
    },
    removeTermWidget() {      
      if(this.$route.params.term_hash && this.$route.params.term_hash != '') {
        if(document.getElementById('min-widget')) {
          document.getElementById('min-widget').parentElement.remove();
        }else{
          setTimeout(() => {
            this.removeTermWidget();
          }, 1000);
        }
      }
    },
  },

  async created() {
    this.isLoading = true
    this.resetBookingDetails()
    try {
      await this.fetchBookingByUUID(this.ORDER_UUID)
      setTimeout(() => {
        this.isLoading = false
      }, 100)
    } catch (error) {
      this.$router.push('/dashboard/index')
    }
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
    window.addEventListener('popstate', this.handleBackDetails)
    if (this.user.uuid) {
      await this.loadPois()
    }
  },

  mounted() {
    if(this.$route.params.term_hash && this.$route.params.term_hash != '') {
      this.removeTermWidget();
    }
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
    window.removeEventListener('popstate', this.handleBackDetails)
    this.operationStoreCommit({
      mutation: 'RESET_BOOKING_DETAILS',
      value: false,
    })
  },
}
</script>

<style>
.statuscontent {
  display: flex;
  margin-left: auto;
}

.boton {
  padding: 6px;
  margin-top: -10px;
  background-color: #ffffff;
  border-color: #ffffff;
}

.headerinfos {
  display: flex;
  align-items: flex-start;
}

.hoverlink {
  cursor: pointer;
}

.barrasuperior {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 55px;
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100%;
  background-color: white;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.079);
  z-index: 10;
  display: flex;
  align-items: center;
}

.ticketstatus {
  position: relative;
  width: 457px;
  height: 131px;
  padding-top: 20px;
  /* background: #22A06B; */
  border-radius: 10px;
}

.ticket {
  background: #fff;
  width: 425px;
  display: inline-block;
  margin-left: 16px;
  border-radius: 19px;
  position: relative;
  text-align: left;
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.25);
}

.ticketheader {
  padding-left: 20px;
  background: #fff;
  padding-right: 15px;
  padding-top: 30px;
  padding-bottom: 25px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  /* border-bottom-style: dashed;
  border-bottom-width: 2px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px; */
}

.ticketheaderborder {
  margin: 0 0px;
}

.reservation-code {
  width: fit-content;
}

.reservation-status-info {
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-left: auto;
  align-items: flex-end;
}

.ticketicon {
  width: 35px;
  margin-right: 10px;
}

.ticketinfo {
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 30px;
  padding-bottom: 20px;
}

.ticketfooter {
  width: 425px;
  height: auto;
  background: #f1f1f1;
  border: 1px solid #cccccc;
  border-radius: 0px 0px 19px 19px;
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 20px;
  padding-bottom: 25px;
}

.ticketarea {
  height: 580px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.infosidecard {
  width: fit-content;
  height: auto;
  background: #ffffff;
  border: 1px solid #dbdbdb;
  border-radius: 12px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 15px;
}

.inactiveagent {
  text-decoration: line-through;
}

.content-info-area {
  display: flex;
  justify-content: center;
  align-items: top;
}

.infosarea {
  padding-left: 60px;
  padding-top: 20px;
}

.iconarea {
  display: flex;
}

@media screen and (max-width: 930px) {
  .content-info-area {
    display: flex;
    justify-content: center;
  }

  .infosarea {
    padding-left: 20px;
    padding-top: 20px;
    padding-bottom: 30px;
  }

  .ticketarea {
    height: 580px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
}

@media screen and (max-width: 880px) {
  .reservation-status-info {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .ticketstatus {
    position: relative;
    width: 360px;
    height: 131px;
    padding-top: 20px;
    /* background: #22A06B; */
    border-radius: 10px;
  }

  .ticket {
    background: white;
    width: 338px;
    display: inline-block;
    margin-left: 10px;
    border-radius: 19px;
    position: relative;
    text-align: left;
    box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.25);
  }

  .ticketheader {
    padding-left: 25px;
    padding-right: 15px;
    padding-top: 30px;
    padding-bottom: 25px;
  }

  .ticketinfo {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 30px;
  }

  .ticketfooter {
    width: 338px;
    height: auto;
    background: #f1f1f1;
    border: 1px solid #cccccc;
    border-radius: 0px 0px 19px 19px;
    padding-left: 20px;
    padding-right: 10px;
    padding-top: 20px;
    padding-bottom: 25px;
  }

  .ticketarea {
    height: 580px;
    max-width: 390px;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .infosidecard {
    width: fit-content;
    height: auto;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 12px;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 10px;
    padding-bottom: 15px;
  }
}

@media screen and (max-width: 780px) {
  .content-info-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .ticketstatus {
    position: relative;
    width: 360px;
    height: 131px;
    padding-top: 20px;
    /* background: #22A06B; */
    border-radius: 10px;
  }

  .ticket {
    background: white;
    width: 338px;
    display: inline-block;
    margin-left: 10px;
    border-radius: 19px;
    position: relative;
    text-align: left;
    box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.25);
  }

  .ticketheader {
    padding-left: 25px;
    padding-right: 15px;
    padding-top: 30px;
    padding-bottom: 25px;
  }

  .ticketinfo {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 30px;
  }

  .ticketfooter {
    width: 338px;
    height: auto;
    background: #f1f1f1;
    border: 1px solid #cccccc;
    border-radius: 0px 0px 19px 19px;
    padding-left: 20px;
    padding-right: 10px;
    padding-top: 20px;
    padding-bottom: 25px;
  }

  .ticketarea {
    height: 580px;
    max-width: 390px;
    overflow-x: hidden;
    overflow-y: scroll;
    align-self: center;
  }

  .infosidecard {
    width: fit-content;
    height: auto;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 12px;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 10px;
    padding-bottom: 15px;
  }

  .infosarea {
    align-self: center;
    padding-top: 20px;
    padding-bottom: 30px;
    padding-left: 0;
  }
}

@media screen and (max-width: 420px) {
  .iconarea {
    align-items: center;
  }

  .content-info-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .ticketstatus {
    position: relative;
    width: 308px;
    height: 131px;
    padding-top: 20px;
    /* background: #22A06B; */
    border-radius: 10px;
  }

  .ticket {
    background: white;
    width: 285px;
    display: inline-block;
    margin-left: 10px;
    border-radius: 19px;
    position: relative;
    text-align: left;
    box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.25);
  }

  .ticketheader {
    padding-left: 15px;
    padding-right: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .ticketinfo {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 30px;
  }

  .ticketfooter {
    width: 285px;
    height: auto;
    background: #f1f1f1;
    border: 1px solid #cccccc;
    border-radius: 0px 0px 19px 19px;
    padding-left: 20px;
    padding-right: 10px;
    padding-top: 20px;
    padding-bottom: 25px;
  }

  .ticketarea {
    height: 580px;
    max-width: 330px;
    overflow-x: hidden;
    overflow-y: scroll;
    align-self: center;
  }

  .infosidecard {
    width: fit-content;
    height: auto;
    background: #ffffff;
    border: 1px solid #dbdbdb;
    border-radius: 12px;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 10px;
    padding-bottom: 15px;
  }

  .infosarea {
    align-self: flex-start;
    padding-top: 20px;
    padding-bottom: 30px;
    padding-left: 20px;
  }

  .reservation-code {
    width: fit-content;
    display: flex;
  }

  .headerinfos {
    display: flex;
    flex-direction: column;
  }

  .reservation-status-info {
    margin-left: 0;
    align-items: flex-start;
    width: 100%;
  }

  .statuscontent {
    display: flex;
    margin-left: 0;
    margin-top: 10px;
    width: 100%;
  }
}
</style>
